import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-ended',
  templateUrl: './video-ended.component.html',
  styleUrls: ['./video-ended.component.css']
})
export class VideoEndedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
